import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import Tabs from "../../components/shared/Tabs";
import useUser from "../../components/helpers/useUser";
import apiClient from "../../components/utils/apiClient";
import RequestsHistory from "./requestsHistory";
import Loading from "../../components/shared/Loading";
import ActiveRequests from "./ActiveRequests";
import NewRequests from "./NewRequests";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "../../components/helpers/useMediaQuery";

const RequestsHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('nav.requests'));
    const pageTitle = {title: t('nav.requests'), subTitle: ''};

    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);

    const [activeTab, setActiveTab] = useState(0);
    const [isActionLoading, setIsActionLoading] = useState(false);

    const navigate = useNavigate();

    const isMobile = useMediaQuery('(max-width: 768px)');

    const requestsTabs = [
        t('requestsTabs.newRequests'),
        t('requestsTabs.activeRequests'),
        t('requestsTabs.requestsHistory')
    ];


    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])

    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])


  return (
    <div>
      <PageHeader pageTitle={pageTitle} isColored />
      <PageMain>
        <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
        <MainContent>
          <Tabs itemWidth={isMobile ? 100 : 159} activeWidth={isMobile ? 125 : 185} animationWidth={isMobile ? 100 : 159} data={requestsTabs} setActiveTab={setActiveTab} activeTab={activeTab} />

          {activeTab === 0 && <NewRequests vendorId={vendor?._id} city={vendor?.city} fields={vendor?.fields} country={vendor?.country} setIsActionLoading={setIsActionLoading} showWarning={vendor?.credits < vendor?.minimumCreditToReceiveOrders } />}
          {activeTab === 1 && <ActiveRequests vendorId={vendor?._id} setIsActionLoading={setIsActionLoading} />}
          {activeTab === 2 && <RequestsHistory vendorId={vendor?._id} setIsActionLoading={setIsActionLoading} />}

          <br />
        </MainContent>
      </PageMain>

      {(!vendor || isActionLoading) && <Loading showLoading={true} />}
    </div>
  );
};

export default RequestsHomePage;
